$(document).ready(function () {

  // deodorant-spray
  if($('.product__title h1').attr('rel') == 7206619152493 || $('#QuickAdd-7206619152493').attr('open') || $('#Badge--7206619152493').length > 0){
    //$('.product-custom-message').removeClass('displaynone');
    setTimeout(function(){
      $('.product-form__input input[type=radio]').attr("checked", false);
      $('.product-form__input input[name="Deodorant Spray Custom"]:nth-of-type(1) + label').trigger('click');
    },600);

    
    $('.product variant-selects').addClass('displaynone');
    setInterval(function(){         
        $('.product variant-selects').hide();       
    },500)

    $('body').prepend('<div class="option_data displaynone"></div>')
    $('.product variant-selects').after(`
     <fieldset class="js product-form__input product-form__input--pill custom_option">
        <input type="radio" id="1box" name="Deodorant Spray Custom"><label for="1box"><div class="prd_vari_price"><strong class="unit_price" rel="$29.99" data="29.99" cp="40.00" valid=""><span class="metafield-money">$29.99</span><i class="fs12">Per box</i></strong><p><strong class="">1 Box</strong></p></div><span class="option_desc save_per_0"><b>Original Price</b></span><div class="vari_image_wrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/Group_233.png?v=1761704855" alt="" class="vari_image displaynone"></div></label>
        <input type="radio" id="2box" name="Deodorant Spray Custom"><label for="2box"><div class="prd_vari_price"><strong class="unit_price" rel="$49.99" data="49.99" cp="80.00" valid=""><span class="metafield-money">$24.99</span><i class="fs12">Per box</i></strong><p><strong class="">2 Boxes</strong></p></div><span class="option_desc save_per_0"><b>Original Price</b></span><div class="vari_image_wrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/Group_231.png?v=1761704856" alt="" class="vari_image displaynone"></div></label>
        <input type="radio" id="4box" name="Deodorant Spray Custom"><label for="4box"><div class="prd_vari_price"><strong class="unit_price" rel="$79.99" data="79.99" cp="160.00" valid=""><span class="metafield-money">$19.99</span><i class="fs12">Per box</i></strong><p><strong class="">4 Boxes</strong></p></div><span class="option_desc save_per_0"><b>Original Price</b></span><div class="vari_image_wrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/Group_267.png?v=1761704855" alt="" class="vari_image displaynone"></div><span class="option_badge" rel="Most Popular">Most Popular</span></label>
        <input type="radio" id="6box" name="Deodorant Spray Custom"><label for="6box"><div class="prd_vari_price"><strong class="unit_price" rel="$113.99" data="113.99" cp="240.00"  valid=""><span class="metafield-money">$18.99</span><i class="fs12">Per box</i></strong><p><strong class="">6 Boxes</strong></p></div><span class="option_desc save_per_0"><b>Original Price</b></span><div class="vari_image_wrap"><img src="https://cdn.shopify.com/s/files/1/0715/3385/5010/files/Group_234.png?v=1761704855" alt="" class="vari_image displaynone"></div><span class="option_badge" rel="Best Value">Best Value</span><span class="option_badge free">FREE SHIPPING</span></label>
     </fieldset>
    `);
    $('.custom_option').after(`
      <div class="option_select c_opts">
        <div>
          <span class="aqua">Aqua Bloom</span><div class="input_wrap"><input name="c_opt1" id="c_input1" class="c_input" type="number" min="0" max="2" placeholder="0" value="0" numberonly="" readonly=""><div class="inc countchk">+</div><div class="dec countchk">-</div></div>
        </div>
        <div>
          <span class="berry">Sweet Berry</span><div class="input_wrap"><input name="c_opt2" id="c_input2" class="c_input" type="number" min="0" max="2" placeholder="0" value="0" numberonly="" readonly=""><div class="inc countchk">+</div><div class="dec countchk">-</div></div>
        </div>
        <div>
          <span class="cotton">Soft Cotton</span><div class="input_wrap"><input name="c_opt3" id="c_input3" class="c_input" type="number" min="0" max="2" placeholder="0" value="0" numberonly="" readonly=""><div class="inc countchk">+</div><div class="dec countchk">-</div></div>
        </div>
        <p class="max_txt"></p>
      </div>
    `);

    $('.product-form__buttons').prepend('<div class="option_select_comp"><b>SELECT</b></div>');
    $('.product-form__buttons').css({'position':'relative'})
    
    $(".countchk").click(function() {   
         $('.c_input').removeClass('off');
          var $button = $(this);
          var $input = $button.parent().find("input");
          var oldValue = parseInt($input.val(), 10) || 0;
          var newVal = oldValue;

          var isPlus = $button.text() === "+";

          /* ------------------------------
              c_opts3 : 0,2,4,6...
          ------------------------------ */
          if ($('.c_opts').hasClass('c_opts3')) {
              if (isPlus) {
                  newVal = oldValue + 2;
              } else {
                  newVal = oldValue - 2;
              }

              // 최소값 0 보정
              if (newVal < 0) newVal = 0;
          }

          /* ------------------------------
              c_opts4 : 0,2,3,6
          ------------------------------ */
          else if ($('.c_opts').hasClass('c_opts4')) {
              var stepArr = [0, 2, 3, 6];
              var idx = stepArr.indexOf(oldValue);

              // 값이 배열에 없을 경우 가장 가까운 값으로 보정
              if (idx === -1) idx = 0;

              if (isPlus && idx < stepArr.length - 1) {
                  newVal = stepArr[idx + 1];
              } else if (!isPlus && idx > 0) {
                  newVal = stepArr[idx - 1];
              }
          }

          /* ------------------------------
              기본 동작 (기존 로직)
          ------------------------------ */
          else {
              var minVal = 1;
              if ($('.c_opts').hasClass('c_opts1')) minVal = 1;

              if (isPlus) {
                  newVal = oldValue + 1;
              } else {
                  newVal = oldValue - 1;
              }

              if (newVal < minVal) newVal = minVal;
          }

          $input.val(newVal);
        var sum = 0;
        $('.c_input').each(function(){
            sum += Number($(this).val());
        });

        // 선택한 옵션 개수 출력
        var opt_max = 0;
        var opt_max_basic = 0;
        var opt_max_add = 0;
        setTimeout(function(){
          if($('.c_opts').hasClass('c_opts1')){
            opt_max = 1;
            opt_max_basic = 1;
          }else if($('.c_opts').hasClass('c_opts2')){
            opt_max = 2;
            opt_max_basic = 2;
          }else if($('.c_opts').hasClass('c_opts3')){
            opt_max = 4;
            opt_max_basic = 4;
          }else if($('.c_opts').hasClass('c_opts4')){
            opt_max = 6;
            opt_max_basic = 6;
          }

          var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span class='red' style='color:blue'>("+sum+"/"+opt_max_basic+")</span></div>";
          
          if(sum == opt_max_basic){            
            var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span class='red' style='color:red'>("+opt_max_basic+"/"+opt_max_basic+")</span></div>";
            $('.option_select_comp, .xans-product-detail .xans-product-option .ec-product-button').hide();
          }
          if(sum >= opt_max_basic && sum <= opt_max){            
            var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span style='color:red'>("+opt_max_basic+"/"+opt_max_basic+")</span></div>";
            $('.option_select_comp, .xans-product-detail .xans-product-option .ec-product-button').hide();
          }
          if(sum == opt_max){            
            var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span style='color:red'>("+opt_max_basic+"/"+opt_max_basic+")</span></div>";       
            $('.option_select_comp, .xans-product-detail .xans-product-option .ec-product-button').show();
          }
          if(sum > (opt_max_basic + opt_max_add) ){            
            var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span style='color:blue'>("+0+"/"+opt_max_basic+")</span></div>";
            $('.option_select_comp, .xans-product-detail .xans-product-option .ec-product-button').hide();
          }
          $('.max_txt').html(opt_max_txt);
        },200)
        // //선택한 옵션 개수 출력   

        if($('.c_opts').hasClass('c_opts1')){
            if(sum == 1){
                $('.c_input').attr('disabled',true);
                $('.option_select_comp').addClass('on');
            }else if(sum > 1){
                $('.c_input').val(0);
                $(this).parent().find('input').val(1);
                $('.option_select_comp').removeClass('on');
                setTimeout(function(){
                  sum = 1;
                  opt_max_txt = "<div>Please select "+opt_max+" items. <span class='red' style='color:red'>("+sum+"/"+opt_max+")</span></div>";
                  $('.option_select_comp').addClass('on').addClass('select_fin');
                },150)
            }else if(sum < 1){
                $('.option_select_comp').removeClass('on').removeClass('select_fin');
            }     
        }else if($('.c_opts').hasClass('c_opts2')){
          if(sum == 2){
              $('.c_input').attr('disabled',true);
              $('.option_select_comp').addClass('on');
          }else if(sum > 2){
              alert('Please select 2 items.');
              $('.c_input').val(0);
              $('.option_select_comp').removeClass('on').removeClass('select_fin');
          }else if(sum < 2){
              $('.option_select_comp').removeClass('on').removeClass('select_fin');
          }        
        }else if($('.c_opts').hasClass('c_opts3')){
            if(sum == 4){
                $('.c_input').attr('disabled',true);
                $('.option_select_comp').addClass('on');
            }else if(sum > 4){
                alert('Please select 4 items.');
                $('.c_input').val(0);
                $('.option_select_comp').removeClass('on').removeClass('select_fin');
            }else if(sum < 4){
                $('.option_select_comp').removeClass('on').removeClass('select_fin');
            }        
        }else if($('.c_opts').hasClass('c_opts4')){
            if(sum == 6){
                $('.c_input').attr('disabled',true);
                $('.option_select_comp').addClass('on');
            }else if(sum > 6){
              alert('Please select 6 items.');
              $('.c_input').val(0);
              $('.option_select_comp').removeClass('on').removeClass('select_fin');
            }else if(sum < 6){
                $('.option_select_comp').removeClass('on').removeClass('select_fin');
            }  
        }else{         
          $('.cd_select').hide();
          $(".c_opts td p .button").off('click');
          $('.c_input').attr('disabled',false);     
          $('.c_input').val(0);
          $('.option_select_comp').removeClass('on');
      }   
    });

    $(`input[name="Deodorant Spray Custom"]`).change(function(){    
        var checkedIndex = $(`input[name="Deodorant Spray Custom"]`).index($(`input[name="Deodorant Spray Custom"]:checked`)) + 1;    
        $('.c_input').val(0);                  
        if(!checkedIndex || checkedIndex == '-1'){
            $('.c_opts .dim').show();                
        } else{                
            $('.c_opts .dim').hide();    
            $(".c_opts").removeClass("c_opts-1 c_opts1 c_opts2 c_opts3 c_opts4 c_opts5");
            $('.c_opts').addClass('c_opts'+checkedIndex);
        }         
      
        var opt_max = 0;
        var opt_max_basic = 0;
        var opt_max_add = 0;
        setTimeout(function(){
          if($('.c_opts').hasClass('c_opts1')){
            opt_max = 1;
            opt_max_basic = 1;
          }else if($('.c_opts').hasClass('c_opts2')){
            opt_max = 2;
            opt_max_basic = 2;
          }else if($('.c_opts').hasClass('c_opts3')){
            opt_max = 4;
            opt_max_basic = 4;
          }else if($('.c_opts').hasClass('c_opts4')){
            opt_max = 6;
            opt_max_basic = 6;
          }else{
            opt_max = 0;
            opt_max_basic = 0;
          }
          var opt_max_txt = "<div>Please select "+opt_max_basic+" items. <span style='color:blue'>("+0+"/"+opt_max_basic+")</span></div>";
          $('.max_txt').html(opt_max_txt);
          $('.option_select_comp').removeAttr('rel');
          $('.option_select_comp').attr('rel', opt_max);
        },200)
    })

    $('.option_select_comp').on('click', function() {
      if($(this).hasClass('on')){   
        $('.c_input').addClass('off');
        $(this).addClass('select_fin');

        var c_input1 = $('#c_input1').val() ? $('#c_input1').val() : '0';
        var c_input2 = $('#c_input2').val() ? $('#c_input2').val() : '0';
        var c_input3 = $('#c_input3').val() ? $('#c_input3').val() : '0';   
        var box = $(this).attr('rel');
        if(box > 1){
          var box_fin = $(this).attr('rel')+' Boxes';
        }else{
          var box_fin = $(this).attr('rel')+' Box';
        }

        //$('.option_data').html('<span>B'+c_input1+'S'+c_input2+'C'+c_input3+'</span>');  
        
        $('.option_data').html('<span>'+box_fin+' - <span rel="'+c_input1+'">Aqua Bloom '+c_input1+'</span><span rel="'+c_input2+'"><i> / </i>Sweet Berry '+c_input2+'</span><span rel="'+c_input3+'"><i> / </i>Soft Cotton '+c_input3+'</span></span>');  
        $(".option_data span[rel='0']").remove();
        $(".option_data span span:first-child:not([rel='0']) i").remove();
        
        var select_option_fin = $('.option_data > span').text();    
        $('input[name^="Deodorant Spray-1"]').filter(function() {
          return $(this).val().includes(select_option_fin);
        }).each(function() {
            
          $(this).trigger('click');
          $(this).attr("checked", true);
          $(this).next('label').trigger('click');       
              
          const selectedVal = $(this).next('label').find('strong').attr('valid');
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selectedVal);     
          window.history.replaceState({}, '', url);
        });
                
        setTimeout(function(){
          
            //$('.product-form__buttons button').trigger('click');
        },300)

      }else{
        var comp_cnt = $(this).attr('rel');
        alert('Please select ' + comp_cnt + ' items.');
      }  
    });

    
  }  
})